import React from "react";
import Grid from "@mui/material/Grid2";
import { Outlet } from "react-router-dom";

const Orders = () => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        margin: "auto",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Outlet />
    </Grid>
  );
};

export default Orders;
